import {Component, OnDestroy, OnInit} from '@angular/core';
import {MatIconModule} from "@angular/material/icon";
import {MatButtonModule} from "@angular/material/button";
import {MatTabsModule} from '@angular/material/tabs';
import {provideNativeDateAdapter} from '@angular/material/core';
import {MatTableDataSource, MatTableModule} from '@angular/material/table';
import {KeyValuePair} from 'allai-admin-shared';
import {Router} from '@angular/router';
import {PatientsService} from "../../../../services/patients/patients-service";

/** The organization detail page */
@Component({
	selector: 'app-patient-detail',
	imports: [
		MatIconModule,
		MatButtonModule,
		MatTabsModule,
		MatTableModule
	],
	providers: [provideNativeDateAdapter()],
	templateUrl: './patient-detail.component.html',
	styleUrl: './patient-detail.component.scss'
})

export class PatientDetailComponent implements OnInit, OnDestroy {

	patientDataSource:MatTableDataSource<KeyValuePair>;
	readonly displayedColumns:(keyof KeyValuePair)[] = ['key', 'value'];

	constructor(private patientsService:PatientsService, private router:Router) {

	}

	ngOnInit() {
		this.refresh();
	}

	private refresh() {

		let patientDetail = this.patientsService.patientDetail;
		let data:KeyValuePair[] = [];
		if(patientDetail) {
			data = [
				{key: "Id", value: patientDetail.patient.id},
				{key: "Name", value: `${patientDetail.patient.first_name} ${patientDetail.patient.last_name}`},
				{key: "Email", value: patientDetail.patient.email},
				{key: "Phone", value: patientDetail.patient.phone},
				{key: "Birthdate", value: patientDetail.patient.birthdate},
				{key: "Sex", value: patientDetail.patient.sex},
				{key: "Race", value: patientDetail.patient.race},
				{key: "Ethnicity", value: patientDetail.patient.ethnicity},
				{
					key: "Organization",
					value: `${patientDetail.organization.id} - ${patientDetail.organization.name}`,
					link: {path: "organization", id: patientDetail.organization.id}
				}
			]
		}
		this.patientDataSource = new MatTableDataSource<KeyValuePair>(data);
	}

	ngOnDestroy() {
	}

	gotoRow(row:KeyValuePair) {
		if(row.link) {
			let url = this.router.serializeUrl(this.router.createUrlTree(['/', row.link.path, row.link.id]));
			window.open(url, `_${row.link.path}_${row.link.id}`);

		}
	}
}
